/**
 * Ruta `/pantalla` (T020; US2 · T038): la única pantalla del marcador configurado, gobernada por
 * la máquina de estados `MarkerState` (`features/display/marker-state.ts`). La vista y el cableado
 * con el canal viven en `features/display/{display-screen.tsx,use-marker.ts}`.
 *
 * Sin credencial no se llega aquí (el gate de `/` manda a `/activar`); si la sesión se revoca
 * mientras la pantalla está abierta, `DisplayScreen` navega al destino de `revokeTarget`.
 */
import { createFileRoute } from '@tanstack/react-router';

import { DisplayScreen } from '../features/display/display-screen';

export const Route = createFileRoute('/pantalla')({
  component: DisplayComponent,
});

/** El componente de la ruta no recibe props: el hook usa el manager real sobre WebSocket. */
function DisplayComponent() {
  return <DisplayScreen />;
}
